import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["alert"]
  static values = { dismissTime: Number }

  connect() {
    this.setupAutoDismiss()
  }

  setupAutoDismiss() {
    const alerts = document.querySelectorAll('[data-auto-dismiss]')
    
    alerts.forEach((alert) => {
      const dismissTime = parseInt(alert.getAttribute('data-auto-dismiss')) || 5000
      
      setTimeout(() => {
        try {
          if (alert && typeof bootstrap !== 'undefined' && bootstrap.Alert) {
            const bsAlert = new bootstrap.Alert(alert)
            bsAlert.close()
          }
        } catch (error) {
          console.error("Error dismissing alert:", error)
        }
      }, dismissTime)
    })
  }
} 